import { supabase } from './supabaseClient';
import { SUPABASE_REDIRECT_URL } from '../env';

export class AuthClient {
  /**
   * SUPABASE_URL has to be set in supabase config -> auth -> URLS
   * SUPABASE_REDIRECT_URL has to be set in .env
   * Sign up a new user
   * @param email - The email of the user
   * @param password - The password of the user
   * @returns The user data
   */

  static async signUp(email: string, password: string) {
    const { data, error } = await supabase.auth.signUp({
      email: email,
      password: password,
      options: {
        emailRedirectTo: SUPABASE_REDIRECT_URL,
      },
    });
    if (error) {
      throw error;
    }
    return data;
  }

  static async loginWithPassword(email: string, password: string) {
    const { data, error } = await supabase.auth.signInWithPassword({
      email: email,
      password: password,
    });
    if (error) {
      throw error;
    }
    return data;
  }

  static async loginWithEmailLink(email: string) {
    const { data, error } = await supabase.auth.signInWithOtp({
      email: email,
    });
    if (error) {
      throw error;
    }
    return data;
  }

  static async signOut() {
    const { error } = await supabase.auth.signOut();
    if (error) {
      throw error;
    }
  }
}
